import { RejectApprovalFlowActivity } from 'modules/approvals/activities/RejectApprovalFlow'
import { CompanyLinksEditActivity } from 'modules/dashboard/activities/CompanyLinksEdit'
import { TeamStatusActivity } from 'modules/dashboard/activities/TeamStatus'
import { DiscardTaskActivity } from 'modules/inbox_tasks/activities/DiscardTask'
import { NoPermissionTaskActivity } from 'modules/inbox_tasks/activities/NoPermissionTask'
import { TaskActivity } from 'modules/inbox_tasks/activities/Task'
import { NotificationActivity } from 'modules/notifications/activities/Activity'
import { EmployeeTest } from 'modules/playground/activities/EmployeeTest'

import { sidebarManifest } from './sidebar'
import type { DomainManifest } from './types'

export const manifest = {
  sidebar: (navigation) => ({
    items: sidebarManifest(navigation),
  }),
  activities: {
    rejectApprovalFlow: {
      component: RejectApprovalFlowActivity,
    },
    dashboardTeamStatus: {
      component: TeamStatusActivity,
    },
    dashboardCompanyLinksEdit: {
      component: CompanyLinksEditActivity,
    },
    employeeTest: {
      component: EmployeeTest,
    },
    notificationsActivity: {
      component: NotificationActivity,
    },
    task: {
      component: TaskActivity,
    },
    discardTask: {
      component: DiscardTaskActivity,
    },
    noPermissionTask: {
      component: NoPermissionTaskActivity,
    },
  },
} as const satisfies DomainManifest
